import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { setNavigate } from './utils/authUtils';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardAdmin from './pages/DashboardAdmin';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Test2 from './pages/CentrosDeSalud';
import Ecografistas from './pages/Ecografistas';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Registro from './pages/Registro';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/utils/ScrollToTop';
import PrivateRoute from './components/PrivateRoute';

const NavigationRegistrar: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => { setNavigate(navigate); }, [navigate]);
  return null;
};

function App() {
  return (
      <Router>
        <NavigationRegistrar />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/admin/dashboard" element={<PrivateRoute requiredRole="ADMIN"><DashboardAdmin /></PrivateRoute>} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/centros-medicos" element={<Test2 />} />
          <Route path="/ecografistas" element={<Ecografistas />} />
          <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/registro" element={<Registro />} />
        </Routes>
        <Footer />
      </Router>
  );
}

export default App;